import { expectedUrlParams } from "../../config";
import { artworks, events, eras, personas } from "../../lookup";

export function validateParams(urlParams) {
  const params = {};
  let missingParams = false;

  expectedUrlParams.forEach((param) => {
    if (urlParams.has(param.name)) {
      const value = urlParams.get(param.name);
      const decodedValue = decodeURIComponent(value || "").trim();

      // Treat empty or whitespace-only strings as missing
      if (decodedValue === "") {
        missingParams = true;
        return;
      }

      // Validate the value based on the type
      if (param.type === "integer") {
        params[param.name] = parseInt(decodedValue, 10);
      } else {
        params[param.name] = decodedValue;
      }
    } else {
      missingParams = true;
    }
  });

  return { params, missingParams };
}

  export function getArtworkData(id) {
    return artworks.find((artwork) => artwork.id === id);
  }

  export function getEventData(id) {
    return events.find((event) => event.id === id);
  }

  export function getEraData(id) {
    return eras.find((era) => era.id === id);
  }

  export function getPersonaData(id) {
    return personas.find((persona) => persona.id === id);
  }
